import { FeedbackFormData } from 'src/modules/feedback/types/FeedbackFormData';
import { FormRule } from 'src/modules/form/types/FormRule';
import * as R from 'src/modules/form/utils/rules';

export const FEEDBACK_FORM_SCHEMA: FormRule<FeedbackFormData> = R.struct({
  rating: R.required(),
  comment: R.maxLength(500),
  contact: R.pass(),
});
